export default "__VITE_ASSET__DEgk0hG5__"